import { FC } from 'react'
import { Building, Home } from '@carbon/icons-react'
import { useTranslation } from 'react-i18next'
import { DS_TYPOGRAPHY_BODY_MD_REGULAR } from '@shared/ui'

type SRCheckboxProps = {
  officeControl: boolean
  officeAddress: string
  homeAddress?: string
  isAxis?: boolean
}

export const SRFormAdress: FC<SRCheckboxProps> = ({
  officeControl,
  officeAddress = '',
  homeAddress = '',
  isAxis = false,
}) => {
  const { t } = useTranslation()
  const Icon = officeControl ? Building : Home
  const address = officeControl ? officeAddress : homeAddress
  const addressKey = officeControl ? 'common:office' : 'common:home'

  return (
    <div className={`flex items-center text-gray-400 ${isAxis ? DS_TYPOGRAPHY_BODY_MD_REGULAR : ''}`}>
      <Icon className="mr-2 w-1/12" size={24} />
      {t(addressKey) + ':'} {address || t('common:noAddress')}
    </div>
  )
}
